var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconThumbsUp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.979736 18.1939H3.72568C6.52417 18.0356 9.1545 16.8067 11.0716 14.7619C12.9886 12.717 14.0454 10.013 14.023 7.21008C14.023 5.03941 18.1419 4.76482 18.1419 8.88373C17.9314 11.5663 17.4718 14.2235 16.7689 16.8209H27.7527C28.2989 16.8209 28.8227 17.0379 29.209 17.4241C29.5952 17.8103 29.8122 18.3342 29.8122 18.8804C29.8122 19.4266 29.5952 19.9504 29.209 20.3366C28.8227 20.7228 28.2989 20.9398 27.7527 20.9398H26.3797C26.9259 20.9398 27.4498 21.1568 27.836 21.543C28.2222 21.9292 28.4392 22.4531 28.4392 22.9993C28.4392 23.5455 28.2222 24.0693 27.836 24.4555C27.4498 24.8418 26.9259 25.0587 26.3797 25.0587H25.0068",
    stroke: "var(--success-color, #74c542)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0068 25.0586C25.553 25.0586 26.0768 25.2756 26.463 25.6618C26.8492 26.048 27.0662 26.5719 27.0662 27.1181C27.0662 27.6643 26.8492 28.1881 26.463 28.5743C26.0768 28.9605 25.553 29.1775 25.0068 29.1775H23.6338C24.18 29.1775 24.7038 29.3945 25.09 29.7807C25.4763 30.1669 25.6932 30.6908 25.6932 31.237C25.6932 31.7832 25.4763 32.307 25.09 32.6932C24.7038 33.0795 24.18 33.2964 23.6338 33.2964H14.7095C9.21757 33.2964 11.9635 30.5505 0.979736 30.5505",
    stroke: "var(--success-color, #74c542)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09863 11.3287V8.58276",
    stroke: "var(--success-color, #74c542)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.72559 9.95581H6.47153",
    stroke: "var(--success-color, #74c542)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5906 4.46396V1.71802",
    stroke: "var(--success-color, #74c542)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21753 3.09082H11.9635",
    stroke: "var(--success-color, #74c542)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3203 7.20994V4.46399",
    stroke: "var(--success-color, #74c542)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9473 5.83691H25.6932",
    stroke: "var(--success-color, #74c542)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1851 14.0747V11.3287",
    stroke: "var(--success-color, #74c542)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8123 12.7017H32.5582",
    stroke: "var(--success-color, #74c542)",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThumbsUp);
export default __webpack_public_path__ + "static/media/Icon_thumbs_up.10202b6e.svg";
export { ForwardRef as ReactComponent };